import { SCROLL_INTO_ELEMENT, CLEAR_SCROLL_TO } from './actions';

const initialState = {
  id: null,
  parentId: null,
  type: null,
};

export default function scrollTo(state = initialState, action) {
  switch (action.type) {
    case SCROLL_INTO_ELEMENT:
      return {
        id: action.id,
        parentId: action.parentId,
        type: action.itemType,
      };
    case CLEAR_SCROLL_TO:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/scroll/reducer.js